export const newUpgrade = (version: string, script: (project: any) => any) => ({
    version: version,
    apply: (project: any) => script({ ...project, version: version })
});